import { render, staticRenderFns } from "./fastStart.vue?vue&type=template&id=2427eb02&scoped=true&"
import script from "./fastStart.vue?vue&type=script&lang=js&"
export * from "./fastStart.vue?vue&type=script&lang=js&"
import style0 from "./fastStart.vue?vue&type=style&index=0&id=2427eb02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2427eb02",
  null
  
)

export default component.exports